export default __webpack_public_path__ + "text_us.8429f02c.png";